import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { PropertyCard } from "@/components/PropertyCard";
import { SectionTitle } from "@/components/Bits";
import { useLang } from "@/context/LanguageContext";

export default function Projects() {
  const { t } = useLang();
  const [props, setProps] = useState([]);
  useEffect(() => { (async () => { const { data } = await api.get("/properties", { params: { limit: 40 } }); setProps(data); })(); }, []);
  return (
    <div className="bg-ivory min-h-screen">
      <section className="bg-navy py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16">
          <SectionTitle light eyebrow={t("pages.projects.eyebrow")} title={t("pages.projects.title")} subtitle={t("pages.projects.subtitle")} />
        </div>
      </section>
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 py-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-7">
        {props.map((p) => <PropertyCard key={p.id} property={p} />)}
      </div>
    </div>
  );
}
